// src/redux/slices/menuSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface MenuItem {
  pk_id: string;
  restaurant_id: string;
  sku_id: string;
  name: string;
  category: string;
  description: string;
  price: string;
  large_price: string;
  indining_price: string;
  indining_large_price: string;
  image: string;
  is_enabled: boolean;
  product_description: string;
  level1_category: string;
  level2_category: string;
  ingredients: string[];
  allergens: string[];
  food_type: string;
  is_vegan: string;
  modifiers_list: any[];
  party_orders: any[];
  // ... other properties from the API response
  [key: string]: any;
}

interface MenuState {
  data: MenuItem[] | null;
  loading: boolean;
  error: string | null;
  selectedCategory: string | null;
  filteredItems: MenuItem[] | null;
}

const initialState: MenuState = {
  data: null,
  loading: false,
  error: null,
  selectedCategory: null,
  filteredItems: null,
};

export const menuSlice = createSlice({
  name: 'menu',
  initialState,
  reducers: {
    // Fetch menu data actions
    fetchMenuDataRequest: state => {
      state.loading = true;
      state.error = null;
    },
    fetchMenuDataSuccess: (state, action: PayloadAction<MenuItem[]>) => {
      state.loading = false;
      state.data = action.payload;
      state.error = null;
    },
    fetchMenuDataFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
      state.data = null;
    },

    // Category selection and filtering
    setSelectedCategory: (state, action: PayloadAction<string | null>) => {
      state.selectedCategory = action.payload;
      if (state.data) {
        if (action.payload) {
          // Support filtering by main categories and subcategories
          state.filteredItems = state.data.filter(item => 
            item.category === action.payload || 
            item.level1_category === action.payload ||
            item.level2_category === action.payload
          );
        } else {
          state.filteredItems = state.data;
        }
      }
    },

    // Clear menu data
    clearMenuData: state => {
      state.data = null;
      state.error = null;
      state.loading = false;
      state.selectedCategory = null;
      state.filteredItems = null;
    },
  },
});

export const {
  fetchMenuDataRequest,
  fetchMenuDataSuccess,
  fetchMenuDataFailure,
  setSelectedCategory,
  clearMenuData,
} = menuSlice.actions;

export default menuSlice.reducer;
